import React from 'react';
import PropTypes from 'prop-types';

import Steps from './Steps';
import Button from '../../components/Button';
import Processing from '../../components/Processing';
import PaymentApi from '../../payments';

import Net90 from '../../images/icons/net90.svg';
import CreditCards from '../../images/icons/creditcards.svg';

import Api, { Utils } from '../../Api';

export default class PaymentInformation extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor() {
    super();

    Utils.bindThis(
      this,
      [
        'stopListeners',
        'navigate',
        'actionLinkBankAccount',
        'actionLinkCreditCard',
        'nextStep'
      ]
    );

    this.state = {
      user: Api.cache.getUser(),
      retailer: Api.cache.getRetailer(),
      error: null
    };
  }

  componentWillMount() {
    Api.userStartListen(this, 'user');
  }

  componentWillUnmount() {
    this.stopListeners();
  }

  navigate(to) {
    this.stopListeners();
    this.context.router.push(to);
  }

  nextStep() {
    if (!this.state.user.addresses || this.state.user.addresses.length <= 0) {
      this.navigate('/checkout/address');
    } else {
      this.navigate('/checkout/delivery');
    }
  }

  stopListeners() {
    Api.userStopListen(this);
  }

  actionLinkBankAccount(event) {
    event.preventDefault();
    let paymentPromise = PaymentApi.addBankAccount(this.state.user);
    paymentPromise.then(this.nextStep);

    return paymentPromise;
  }

  actionLinkCreditCard(event) {
    event.preventDefault();
    let paymentPromise = PaymentApi.addCreditCard(this.state.user);
    paymentPromise.then(this.nextStep);

    return paymentPromise;
  }

  render() {
    let error = this.state.error ? <div className="error">{this.state.error}</div> : null;
    // Not checking for 'is_employee' on purpose on the next line.
    let isAdmin = this.state.user && (this.state.user.type === 'ADMIN' || this.state.user.impersonating);
    let retailerCanSkip = this.state.retailer && this.state.retailer.can_skip_payment;
    let skipButton = null;
    if (isAdmin || retailerCanSkip) {
      skipButton = <Button onClick={this.nextStep}>Skip</Button>;
    }

    return (
      <div>
        <Steps current="2" />
        <div className="page-flyout checkout checkout-payment">
          <h2 className="flyout-header">Select a Payment Method</h2>
          <div>
            <div className="payment-options">
              <CreditCardPayment onClick={this.actionLinkCreditCard} />
              <NetNinetyPayment onClick={this.actionLinkBankAccount} />
            </div>
            {skipButton}
            {error}
            <p className="note">
              By linking a payment instrument, you authorize Indigo Fair. I authorize to electronically debit your
              account and, if necessary, electronically credit account to correct erroneous debits.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class CreditCardPayment extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string,
    title: PropTypes.string
  };

  static defaultProps = {
    title: 'Pay With Credit Card',
    buttonText: 'LINK CARD'
  };

  render() {
    return (
      <div className="payment-option creditcard">
        <h3>{this.props.title}</h3>
        <img src={CreditCards} role="presentation" />
        <p>
          Your credit card will be charged  for items and freight costs at the  time of shipment.
          You will receive a  full refund for all items you return.
        </p>
        <div className="button-wrapper">
          <Button className="round" onClick={this.props.onClick} waitingState={<Processing />}>{this.props.buttonText}</Button>
        </div>
      </div>
    );
  }
}

class NetNinetyPayment extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string,
    title: PropTypes.string
  };

  static defaultProps = {
    title: 'PAY USING NET 90',
    buttonText: 'LINK BANK'
  };

  render() {
    return (
      <div className="payment-option net90">
        <h3>{this.props.title}</h3>
        <img src={Net90} role="presentation" />
        <p>
          Your bank account will be charged 90 days after items ship.
          Freight costs will be charged upon shipment.
          You will never be charged for returned items.
         </p>
        <div className="button-wrapper">
          <Button className="round" onClick={this.props.onClick} color="white" waitingState={<Processing />}>{this.props.buttonText}</Button>
        </div>
      </div>
    );
  }
}

export {
  CreditCardPayment,
  NetNinetyPayment
};



/** WEBPACK FOOTER **
 ** ./src/views/checkout/PaymentInformation.js
 **/